document.querySelectorAll('span.options>input[type=checkbox]').forEach((ele)=>{
  ele.addEventListener('change',function(){
    if(this.checked){
      blogFilter(this.value,true);
    }else{
      blogFilter(this.value,false);
    }
  });
});

let blogFilter = (filterValue,checkFilter)=>{
  document.querySelector('.blog-filter-wrapper').classList.add('loading');
  let url = location.pathname+'/tagged/'+filterValue+'?section_id=blog-filter-data',
  getId = '#get-blog-posts';
  if(filterValue === 'clear'){
    url = location.pathname;
    getId = '#blog-posts';
  }
  fetch(url,{
    method:'get'
  }).then((res)=>res.text()).then((res)=>{
    let filData = new DOMParser().parseFromString(res, 'text/html').querySelector(getId);
    setFilterHtml(filData,checkFilter,filterValue)
  }).finally(() => {
    if($(document).find('.blog-articles__article').length){
      var articleArray =  [];
      var duplicateHandles = [];
      $(document).find('.blog-articles__article').removeClass('hidden');
      $(document).find('.blog-articles__article').each(function(item){
        var getHandle = $(this).data('handle');
        if (articleArray.indexOf(getHandle) !== -1) {
          duplicateHandles.push(getHandle);
        } else {
          articleArray.push(getHandle);
        }
      });
      $.each(duplicateHandles, function(index, value) {
        $(document).find('.blog-articles__article[data-handle="'+value+'"]').each(function(index){
          if(index !== 0){
            $(this).addClass('hidden');
          }
        });
      });
    }
  cutomPaginate();
  setTimeout(()=>{
    document.querySelector('.blog-filter-wrapper').classList.remove('loading');
  },500);
  })
};


let setFilterHtml = async (filData,checkFilter,filterValue)=>{
    if(checkFilter){
      if(filterValue != 'clear'){
        filData.querySelectorAll('.blog-articles__article').forEach((ele)=>{
          ele.setAttribute('data-tag',filterValue);
        });
      }
      if(document.querySelectorAll('span.options>input[type=checkbox]:checked').length > 1){
        let oldData = document.querySelector('div#blog-posts').innerHTML;
        // filData = filterData(filData);
        document.querySelector('div#blog-posts').innerHTML = filData.innerHTML+oldData;
      }else{
        document.querySelector('div#blog-posts').innerHTML = filData.innerHTML;
        if(filterValue != 'clear'){
          document.querySelector('div#Huratips-Pagination').style.display = 'none';
        }else{
          document.querySelector('div#Huratips-Pagination').style.display = 'block';
          document.querySelector('#ctm-Huratips-Pagination').style.display = 'none';
        }
      }
    }else{
      if(document.querySelectorAll('span.options>input[type=checkbox]:checked').length){
        filData.querySelectorAll('.blog-articles__article').forEach((ele)=>{
          let handle = ele.dataset.handle;
          if(document.querySelector('.blog-articles__article[data-handle="'+handle+'"][data-tag="'+filterValue+'"]')){
            document.querySelector('.blog-articles__article[data-handle="'+handle+'"][data-tag="'+filterValue+'"]').remove();
          }
        });
        let oldData = document.querySelector('div#blog-posts').innerHTML;
        document.querySelector('div#blog-posts').innerHTML = oldData;
      }else{
        clearFilter();
      }
    }
}

// let filterData = (filData)=>{
//   document.querySelectorAll('div#blog-posts .blog-articles__article').forEach((ele)=>{
//     let checkHandle = ele.dataset.handle;
//     filData.querySelectorAll('.blog-articles__article').forEach((cEle)=>{
//       let filHandle = cEle.dataset.handle;
//       if(checkHandle === filHandle){
//         cEle.remove();
//         return false;
//       }
//     });
//   });
//   return filData;
// }

let clearFilter = ()=>{
  blogFilter('clear',true);
}

document.querySelector('span.blog__reset-btn a.reset-btn').onclick = function(evt){
  evt.preventDefault();
  clearFilter();
  document.querySelectorAll('span.options>input[type=checkbox]').forEach((ele)=>{
    ele.checked = false;
  })
}


let cutomPaginate = ()=>{
  document.querySelectorAll('.blog-articles__article:not(.hidden)').forEach((ele,i)=>{
    if(i>11){
      ele.style.display = 'none';
    }
  });
  if(document.querySelectorAll('.blog-articles__article[style*="display: none"]:not(.hidden)').length === 0){
    document.querySelector('#ctm-Huratips-Pagination').style.display = 'none';
  }else{
    document.querySelector('#ctm-Huratips-Pagination').style.display = 'block';
  }
}

document.querySelector('#ctm-load-more-posts').onclick = function(){
  document.querySelectorAll('.blog-articles__article[style*="display: none"]:not(.hidden)').forEach((ele,i)=>{
    if(i<=11){
      ele.style.display = 'inline-block';
    }
  });
  if(document.querySelectorAll('.blog-articles__article[style*="display: none"]:not(.hidden)').length === 0){
    document.querySelector('#ctm-Huratips-Pagination').style.display = 'none';
  }
}
